module.exports = __webpack_public_path__ + "school/img/childrenCultureDetailBg.0d2a92d7.jpg";